import React, { useState } from 'react';
// Import the corresponding CSS file
import './RefundPolicy.css';
import DefaultData from '../../CompanyData/DefaultData';
// The incorrect import for remixicon has been removed from here

const RefundPolicy = () => {
    // State to manage the open/closed state of the FAQ accordion
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // The formal policy points
    const policyPoints = [
        'Refunds will be processed as per the airline fare rules and cancellation policy. Such refunds shall be subject to BABA AIR Travels receiving the same from the airlines. However, the convenience fee paid to BABA AIR Travels paid at the time of booking is a non-refundable fee.',
        'All cancellations made directly with the airline need to be intimated to BABA Air Travels, in order to initiate the process of refund. The processing time for refunds may vary depending on the mode of payment, bank etc. The refund shall be processed after deducting the BABA AIR Travels service fee which is independent of the convenience fee as mentioned above.',
        'The refund will be credited to the same account from which the payment was made. For example, if the User used a credit card, BABA AIR Travels will make an appropriate charge reversal to the same credit card; like-wise if the User used a debit card, BABA AIR Travels will credit the money to the same debit card.',
        'In the event of cancellation and refund of partially utilized tickets, upfront discount and promo code discount availed at the time of booking would be deducted from the refund amount.'
    ];

    // FAQ data for the accordion section
    const faqData = [
        {
            question: 'What is your cancellation policy?',
            answer: '<p>Cancellation policies vary depending on the airline. You can find detailed information during the booking process, and we recommend reviewing the terms and conditions before finalizing your reservation.</p>'
        },
        {
            question: 'How will I get my money back after a cancellation?',
            answer: '<p>We will credit the money back to the same account you used while making the booking. For example, if you used your credit card, we will make an appropriate charge reversal. If you used your debit card, we will credit the money back to the debit card.</p>'
        },
        {
            question: 'How long does it take to process a refund?',
            answer: '<p>We usually process the refund within 4 working days of cancellation. However, it may take slightly longer to reflect in your account statement depending upon your bank. We’ve noticed that it takes about 14 working days for most refunds to hit their respective accounts.</p>'
        },
        {
            question: 'I still haven’t received my refund. Help!',
            answer: '<p>Please email us at ' + DefaultData?.DEFAULTCOMPANYEMAIL + ' or contact us at ' + DefaultData?.DEFAULTCOMPANYPHONENUMBER + ' with your booking details.</p>'
        },
        {
            question: 'What if I encounter issues during my trip?',
            answer: '<p>Our customer support team is available 24/7 to assist you. Contact us through the provided helpline or email, and we will promptly address any concerns or issues you may have during your journey.</p>'
        }
    ];

    const heroStyle = {
        backgroundImage: `url('/assets/images/Refund.png')`,
    };

    return (
        <div className="main-content">
            <div className="refund-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Refund Policy</h1>
                        <p className="hero-subheading">Our commitment to a clear and fair refund process.</p>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="refund-content-wrapper">
                                
                                {/* Formal Policy Section */}
                                <div className="policy-section">
                                    <h3 className="section-title">General Refund Conditions</h3>
                                    {policyPoints.map((point, index) => (
                                        <p className="policy-text" key={index}>{point}</p>
                                    ))}
                                </div>
                                
                                {/* FAQ Section */}
                                <div className="faq-section">
                                    <h3 className="section-title">Common Questions</h3>
                                    <div className="faq-accordion">
                                        {faqData.map((item, index) => (
                                            <div className={`faq-item ${openIndex === index ? 'is-open' : ''}`} key={index}>
                                                <button className="faq-question" onClick={() => handleToggle(index)}>
                                                    <span>{item.question}</span>
                                                    <i className="ri-arrow-down-s-line faq-icon"></i>
                                                </button>
                                                <div className="faq-answer-content">
                                                    <div className="faq-answer" dangerouslySetInnerHTML={{ __html: item.answer }} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;